export default __webpack_public_path__ + "static/media/about.d73d7b45.jpeg";